import { graphql, compose } from 'react-apollo';
import gql from 'graphql-tag';

export const JOB_PROFILE_CORE_QUERY = gql`query ($accountId: ID!, $id: ID!) {
  account(id: $accountId) {
    id
    jobProfile(id: $id) {
      id
      name
      createdOn
      updatedOn
      internalDescription
      assessmentTemplate {
        id
        title
      }
      createdBy {
        id
        firstName
        lastName
      }
      standardJob {
        id
        industryId
      }
      isUsedForSuperMatch
    }
  }
}
`;

const jobProfileCoreQuery = graphql(JOB_PROFILE_CORE_QUERY, {
  name: 'jobProfileCore',
  options: ({ match, currentAccount }) => {
    const { jobProfileId } = match.params;
    return {
      variables: {
        id: jobProfileId,
        accountId: currentAccount,
      },
    };
  },
});

const JOB_PROFILE_DIMENSIONS_QUERY = gql`query ($accountId: ID!, $id: ID!) {
  account(id: $accountId) {
    id
    jobProfile(id: $id) {
      id
      assessmentTemplate {
        id
        title
      }
      dimensionBenchmarks {
        behaviorBenchmarks {
          displayName
          dimensionBenchmarks {
            code
            displayName
            low
            high
          }
        }
        distortionBenchmark {
          code
          displayName
          low
          high          
        }
        cognitiveBenchmarks {
          displayName
          dimensionBenchmarks {
            code
            displayName
            low
            high
          }
        }
        interestsBenchmarks {
          displayName
          dimensionBenchmarks {
            code
            displayName
            priority
            description
          }
        }
      }
    }
  }
}`;

const jobProfileDimensionsQuery = graphql(JOB_PROFILE_DIMENSIONS_QUERY, {
  name: 'jobProfileDimensions',
  options: ({ match, currentAccount }) => {
    const { jobProfileId } = match.params;
    return {
      variables: {
        id: jobProfileId,
        accountId: currentAccount,
      },
    };
  },
});

export default compose(
  jobProfileCoreQuery,
  jobProfileDimensionsQuery,
);
